<template>
  <PopUpContents
    ref="popup"
    width="48rem"
    height="44rem"
  >
    <div class="container-fluid p-3 bb-tooltip-wrapper">
      <div class="col p-2">
        <div class="row">
          <div class="bb-hdg mb-2 text-center bb-truncate-text">
            {{ subjectItem.name }}
          </div>
        </div>

        <div class="row mt-3 mb-3 align-items-end">
          <div class="col-3 form-group">
            <div class="form-floating">
              <input
                readonly
                class="form-control text-center"
                :value="attachedCount"
                id="attached_count"
                disabled
              />
              <label
                class="bb-float-label optional"
                for="attached_count"
                >Attached Items</label
              >
            </div>
          </div>

          <div class="col-auto form-group ms-auto">
            <div
              class="btn-group special"
              role="group"
            >
              <button
                type="button"
                @click="_cancel"
                class="btn btn-lg btn-warning"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>

        <p class="bb-hdg mb-3">Attached Items</p>

        <div class="row mt-3 mb-3">
          <div class="col">
            <div
              v-if="attachedItems.length === 0"
              class="bb-empty-panel"
            >
              No attached items.
            </div>

            <div
              v-else
              class="form-group"
            >
              <div class="form-floating">
                <v-select
                  :options="attachedItems"
                  :get-option-label="formatAttachedItemLabel"
                  :dropdown-should-open="dropdownShouldOpen"
                  class="form-control contents-dialog-select attached-dialog-select"
                  placeholder="search..."
                  id="attached_item"
                >
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>

                  <template #option="item">
                    <div
                      class="contents-option"
                      :class="
                        item.storage
                          ? 'contents-option-storage'
                          : 'contents-option-non-storage'
                      "
                    >
                      <span
                        :class="
                          item.storage
                            ? 'attached-node-storage-text'
                            : 'attached-node-child-text'
                        "
                      >
                        {{ formatAttachedItemLabel(item) }}
                      </span>
                    </div>
                  </template>

                  <template #selected-option="item">
                    <span
                      class="contents-option-selected"
                      :class="
                        item.storage
                          ? 'contents-option-storage'
                          : 'contents-option-non-storage'
                      "
                    >
                      <span
                        :class="
                          item.storage
                            ? 'attached-node-storage-text'
                            : 'attached-node-child-text'
                        "
                      >
                        {{ formatAttachedItemLabel(item) }}
                      </span>
                    </span>
                  </template>
                </v-select>
                <label
                  class="bb-float-label"
                  for="attached_item"
                  >Item</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PopUpContents>
</template>

<script>
import PopUpContents from './PopUpContents.vue'

export default {
  name: 'AttachedDialog',
  components: {
    PopUpContents,
  },
  data: () => ({
    subjectItem: {},
    characterItems: [],
    attachedItems: [],
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  computed: {
    attachedCount() {
      return Array.isArray(this.attachedItems) ? this.attachedItems.length : 0
    },
  },
  methods: {
    show(opts = {}) {
      this.subjectItem = opts.subjectItem || {}
      this.characterItems = Array.isArray(opts.character?.items)
        ? opts.character.items
        : []
      this.attachedItems = this.getAttachedItems()

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    getAttachedItems() {
      const subjectId = this.subjectItem?.id ?? null

      if (!subjectId) {
        return []
      }

      return this.characterItems
        .filter((item) => item && item.attach_location === subjectId)
        .slice()
        .sort((left, right) => {
          const leftName = (left.display_name || left.name || '').toLowerCase()
          const rightName = (
            right.display_name ||
            right.name ||
            ''
          ).toLowerCase()

          if (leftName < rightName) return -1
          if (leftName > rightName) return 1
          return 0
        })
    },
    itemLabel(item) {
      return item?.display_name || item?.name || 'Unnamed Item'
    },
    dropdownShouldOpen() {
      return true
    },
    formatAttachedItemLabel(item) {
      if (!item) return ''

      const qty = item?.tally_qty
      const enc = item?.enc
      const numericEnc = Number(enc)
      const encLabel = Number.isNaN(numericEnc) ? enc : numericEnc.toFixed(2)

      let label =
        qty != null && qty > 1
          ? `${this.itemLabel(item)} - Enc (${encLabel}) x ${qty}`
          : `${this.itemLabel(item)} - Enc (${encLabel})`

      if (
        item?.storage === true &&
        item?.contents_count_direct != null &&
        item.contents_count_direct > 0
      ) {
        const childWord = item.contents_count_direct === 1 ? 'item' : 'items'
        label += ` [${item.contents_count_direct} ${childWord}]`
      }

      return label
    },
    itemMeta(item) {
      const parts = []
      const qty = item?.tally_qty
      const enc = item?.enc

      if (qty !== null && qty !== undefined) {
        parts.push(`Qty ${qty}`)
      }

      if (enc !== null && enc !== undefined && enc !== '') {
        const numericEnc = Number(enc)
        if (!Number.isNaN(numericEnc)) {
          parts.push(`Enc ${numericEnc.toFixed(2)}`)
        }
      }

      return parts.join(' | ')
    },
    _cancel() {
      this.$refs.popup.close()
      if (this.resolvePromise) {
        this.resolvePromise()
      }
    },
  },
}
</script>

<style scoped>
:deep(.attached-dialog-select) {
  text-transform: none;
}

:deep(.attached-dialog-select .vs__dropdown-menu) {
  display: block;
  position: static;
  border: none;
  box-shadow: none;
}

:deep(.attached-dialog-select .vs__selected-options) {
  max-height: none;
}

:deep(.attached-dialog-select .vs__dropdown-menu) {
  max-height: 25rem;
  overflow-y: auto;
  margin-top: 0;
  padding-top: 0;
  padding-bottom: 0.5rem;
}

:deep(.attached-dialog-select .vs__dropdown-menu),
:deep(.attached-dialog-select .vs__selected),
:deep(.attached-dialog-select .vs__search) {
  text-transform: none;
}

:deep(.attached-dialog-select .contents-option) {
  padding-top: 0.1rem;
  align-items: center;
  display: flex;
  font-size: 0.9em;
}

:deep(.attached-dialog-select .contents-option-storage),
:deep(
  .attached-dialog-select .contents-option-selected.contents-option-storage
) {
  color: #ffffff;
}

:deep(.attached-dialog-select .contents-option-non-storage),
:deep(
  .attached-dialog-select .contents-option-selected.contents-option-non-storage
) {
  color: #7d7c7c;
}

:deep(.attached-dialog-select .attached-node-storage-text) {
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
}

:deep(.attached-dialog-select .attached-node-child-text) {
  color: #7d7c7c !important;
  -webkit-text-fill-color: #7d7c7c !important;
}

.bb-empty-panel {
  color: #7d7c7c;
  font-size: 0.9em;
  padding-top: 0.1rem;
}
</style>
